var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28334 0.5C6.68792 0.5 7.0159 0.827977 7.0159 1.23256V4.16279C7.0159 4.56737 6.68792 4.89535 6.28334 4.89535C5.87876 4.89535 5.55078 4.56737 5.55078 4.16279V1.23256C5.55078 0.827977 5.87876 0.5 6.28334 0.5Z",
    fill: "#0068FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0997 0.5C14.5043 0.5 14.8323 0.827977 14.8323 1.23256V4.16279C14.8323 4.56737 14.5043 4.89535 14.0997 4.89535C13.6952 4.89535 13.3672 4.56737 13.3672 4.16279V1.23256C13.3672 0.827977 13.6952 0.5 14.0997 0.5Z",
    fill: "#0068FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15625 8.15834C1.15625 7.75376 1.48423 7.42578 1.88881 7.42578H18.4935C18.898 7.42578 19.226 7.75376 19.226 8.15834C19.226 8.56292 18.898 8.8909 18.4935 8.8909H1.88881C1.48423 8.8909 1.15625 8.56292 1.15625 8.15834Z",
    fill: "#0068FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09722 4.5389C2.4714 5.21286 2.13309 6.2283 2.13309 7.58112V15.8834C2.13309 17.2363 2.4714 18.2517 3.09722 18.9257C3.71393 19.5898 4.71457 20.0346 6.28425 20.0346H14.0982C15.6679 20.0346 16.6685 19.5898 17.2852 18.9257C17.9111 18.2517 18.2494 17.2363 18.2494 15.8834V7.58112C18.2494 6.2283 17.9111 5.21286 17.2852 4.5389C16.6685 3.87475 15.6679 3.42996 14.0982 3.42996H6.28425C4.71457 3.42996 3.71393 3.87475 3.09722 4.5389ZM2.0236 3.54196C2.9941 2.49679 4.43532 1.96484 6.28425 1.96484H14.0982C15.9471 1.96484 17.3883 2.49679 18.3589 3.54196C19.3202 4.57729 19.7145 6.00371 19.7145 7.58112V15.8834C19.7145 17.4609 19.3202 18.8873 18.3589 19.9226C17.3883 20.9678 15.9471 21.4997 14.0982 21.4997H6.28425C4.43532 21.4997 2.9941 20.9678 2.0236 19.9226C1.06222 18.8873 0.667969 17.4609 0.667969 15.8834V7.58112C0.667969 6.00371 1.06222 4.57729 2.0236 3.54196Z",
    fill: "#0068FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21094 12.6603C9.21094 12.1209 9.64824 11.6836 10.1877 11.6836H10.1965C10.7359 11.6836 11.1732 12.1209 11.1732 12.6603C11.1732 13.1998 10.7359 13.6371 10.1965 13.6371H10.1877C9.64824 13.6371 9.21094 13.1998 9.21094 12.6603Z",
    fill: "#0068FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59766 12.6603C5.59766 12.1209 6.03496 11.6836 6.5744 11.6836H6.58317C7.12261 11.6836 7.55992 12.1209 7.55992 12.6603C7.55992 13.1998 7.12261 13.6371 6.58317 13.6371H6.5744C6.03496 13.6371 5.59766 13.1998 5.59766 12.6603Z",
    fill: "#0068FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59766 15.59C5.59766 15.0506 6.03496 14.6133 6.5744 14.6133H6.58317C7.12261 14.6133 7.55992 15.0506 7.55992 15.59C7.55992 16.1295 7.12261 16.5668 6.58317 16.5668H6.5744C6.03496 16.5668 5.59766 16.1295 5.59766 15.59Z",
    fill: "#0068FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.43877554fa89edaaf19ee75a8c1d89c5.svg";
export { ForwardRef as ReactComponent };